import { createFileRoute } from "@tanstack/react-router";
import { getProgram } from "api-client";
import { assert } from "utils";

import { loaderHandler } from "src/lib/loaderHandler";
import { CoachLibrarySharedProgramLayout } from "src/pages/CoachLibrarySharedProgramLayout";

export const Route = createFileRoute(
  "/_auth/_coach/library/programs/$programId/shared/$sharedProgramId",
)({
  component: RoutePage,
  ssr: true,
  async loader({ params }) {
    return await loaderHandler(async () => {
      assert(params.sharedProgramId, "No sharedProgramId");

      const program = await getProgram({
        path: {
          id: params.sharedProgramId,
        },
      }).then((res) => res.data.data);

      return {
        data: {
          program,
        },
        breadcrumb: {
          id: program.id,
          label: program.name,
          href: `/library/programs/${program.baseProgramId}/shared/${program.id}`,
        },
      };
    });
  },
});

function RoutePage() {
  return <CoachLibrarySharedProgramLayout />;
}
